// extracted by mini-css-extract-plugin
export default {"productBroder":"ProductList_productBroder__twiXT"};